import { render, staticRenderFns } from "./app-footer.vue?vue&type=template&id=2184b530&scoped=true&"
import script from "./app-footer.vue?vue&type=script&lang=ts&"
export * from "./app-footer.vue?vue&type=script&lang=ts&"
import style0 from "./app-footer.vue?vue&type=style&index=0&id=2184b530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2184b530",
  null
  
)

export default component.exports